import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './configure-amplify';

// Import shared styles from frontend-shared
import '@core-systems/frontend-shared/styles/main.scss';
import './index.scss';

import App from './App.tsx';

const rootEl = document.getElementById('root');

createRoot(rootEl!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);
